// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__14cyh","checkboxCol":"Table_checkboxCol__3g2QO","emailCol":"Table_emailCol__1raCt","actionCol":"Table_actionCol__1Nl8j"};